import React, {Component} from 'react';
import { __n, __ } from 'i18n-for-browser';

import Header from '../elements/Header';
import NextStep from '../elements/NextStep';
import PropTypes from 'prop-types';
import connect from "react-redux/es/connect/connect";

/**
 * Import assets
 */
import ContentContainer from "../elements/ContentContainer";
import ListButton from '../elements/ListButton';
import FeedbackImage from '../elements/feedback/FeedbackImage';
import PolicyChoiceLaag from '../elements/PolicyChoiceLaag';
import CaretDown from "../../assets/img/caret_down_grey.svg";
import BeleidskeuzeL from "../../assets/img/icons/beleidskeuze_L.svg";
import { unreadCount, getPolicyChoiceFeedback, getPolicyChoiceTotalPoints, checkRead, getImageText, getText } from '../../helpers/feedbackHelpers';
import { calculateSavingsAndLoans, calculateBudgetBASIC } from '../../helpers/calculationsHelper';
import {
  getTotalCosts,
  getIcon,
  getTitle,
  groupByProblem,
  choicesToMake,
  getOplossingTitle,
  getProbleemTekst,
  getOplossingTekst,
} from '../../helpers/policyChoiceHelper';

import actions from '../../actions';
const { updateRead } = actions.feedback;

class Beleidskeuzes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showProbleemOplossing: undefined,
      showBeleidskeuze: undefined,
      open: undefined,
    };
  }

  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  };

  toggleProbleemOplossing = (id) => {
    let showProbleemOplossing = undefined;
    if (this.state.showProbleemOplossing !== id) {
      showProbleemOplossing = id;
    }
    this.setState({ showProbleemOplossing });
  };

  render() {
    const { gameState, feedback, policyChoice, gameStateInput } = this.props;
    const {prevRoundSum} = gameState;
    if(!prevRoundSum) return null;

    // Filter policy choices to show 1 per number
    const filteredPolicyChoices = groupByProblem(policyChoice);

    const globas = calculateBudgetBASIC(
      gameState,
      gameStateInput.myState.policyChoices,
      gameStateInput.myState.ministerieGlobaVerdeling,
      calculateSavingsAndLoans(gameStateInput),
      policyChoice
    );

    const policyChoiceFeedback = getPolicyChoiceFeedback(feedback.prevRoundFeedbackData);

    return (
      <div>
        <Header history={this.props.history} historic={false} buttonType='close' viewType='list' showTitle={false} showBudget={(gameState.currentStep > 1)}/>

        <div className='container ministry-container'>
          <ListButton
            bgColor='darkblue'
            title={__n('sim_beleidskeuze', 0)}
            icon={BeleidskeuzeL}
            className={"beleidskeuze-listbutton-laag"}
            feedbackCount={
              gameState.currentStep === 3
              ? choicesToMake(policyChoice, gameStateInput.myState.policyChoices, this.props.project.minPolicyChoices)
              : unreadCount(getPolicyChoiceFeedback(feedback.prevRoundFeedbackData), null, true)
            }
            arrow={true}
            redNotification={gameState.currentStep === 3}
            points={gameState.currentStep === 3 ? false : getPolicyChoiceTotalPoints(feedback.prevRoundFeedbackData)}
            globas={gameState.currentStep === 3 ? getTotalCosts(gameStateInput.myState.policyChoices, policyChoice) : undefined}
          />

          <div className={'low-policy'}>
            {gameState.currentStep === 3 ? filteredPolicyChoices.map((pc, i) => {
              if (i < this.props.project.minPolicyChoices) {
                return (
                  <PolicyChoiceLaag
                    key={i}
                    problem={pc}
                    spendableGlobas={globas}
                    show={this.state.open === i}
                    onClick={() => {
                      this.setState({ open: this.state.open === i ? undefined : i });
                    }}
                  />
                )
              } else {
                return false;
              }
            }) : (
              <div className="feedback-list">
                {policyChoiceFeedback.map((feedback, i) => {
                  let title;
                  if (feedback.oplossing_code) {
                    title = getOplossingTitle(feedback, gameState.language);
                  } else {
                    title = getTitle(feedback, gameState.language);
                  }
                  console.log(this.state.open);
                  return (
                    <div className={'feedback-container-low'} key={i}>
                      <ListButton
                        feedbackCount={checkRead(feedback) ? 0 : 1}
                        bgColor={feedback.kleur_balk}
                        title={title}
                        arrow={true}
                        feedback={true}
                        thumbnail={getIcon(feedback)}
                        points={feedback.puntenscore}
                        onClick={() => {
                          let showBeleidskeuze = undefined;
                          if (this.state.showBeleidskeuze !== feedback.omschrijving) {
                            showBeleidskeuze = feedback.omschrijving;
                          }
                          if (!checkRead(feedback)) {
                            feedback.read.read = true;
                            this.props.dispatch(updateRead(feedback.id, feedback.read));
                          }
                          this.setState({ showBeleidskeuze, showProbleemOplossing: false });
                        }}
                      />
                      {this.state.showBeleidskeuze === feedback.omschrijving ? (
                        <div className="low-feedback-policy-choice-container">
                          <ContentContainer className="problem-solution-container">
                            <div className="top-bar" onClick={() => { this.toggleProbleemOplossing(feedback.omschrijving); }}>
                              <h3>{__('sim_bekijk_probleem_en_oplossing')}</h3>
                              <img src={CaretDown} alt={'close'} className={'close-status' + (this.state.showProbleemOplossing === feedback.omschrijving ? ' rotate' : '')}/>
                            </div>
                            <div className={`inner${(this.state.showProbleemOplossing === feedback.omschrijving ? ' show' : '')}`}>
                              <div className="inner-content">
                                <h4>{__('sim_probleem')}</h4>
                                <p>{getProbleemTekst(feedback, gameState.language)}</p>
                              </div>
                              <div className="inner-content">
                                <h4>{__('sim_oplossing')}</h4>
                                <p>{getOplossingTekst(feedback, gameState.language)}</p>
                              </div>
                              <div className="inner-content">
                                <h4>{__('sim_kosten')}:</h4>
                                <span>{`${feedback.kosten_globas || 0} ${__('sim_miljard')}`}</span>
                              </div>
                            </div>
                          </ContentContainer>
                          <FeedbackImage
                            description={getImageText(feedback, gameState.language)}
                            image={feedback.img_2}
                          />
                          <ContentContainer style={{ marginBottom: '10px', }}>
                            <div dangerouslySetInnerHTML={{ __html: getText(feedback, gameState.language) }}/>
                          </ContentContainer>
                          {policyChoiceFeedback.length > i + 1 ? <span className="feedback-list-line" /> : null}
                        </div>
                      ) : null}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        <NextStep/>
      </div>
    );
  }
}

export default connect(({gameState, feedback, policyChoice, gameStateInput, project}) => ({gameState, feedback, policyChoice, gameStateInput, project}))(Beleidskeuzes);



// WEBPACK FOOTER //
// ./src/components/routes/Beleidskeuzes.js